import React from 'react'
import AboutPageSection from '../components/About/AboutPageSection'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'

function AboutUs() {
  return (
    <div>
      <NavBar/>
      <AboutPageSection/>
      <Footer/>

    </div>
  )
}

export default AboutUs